
import React from 'react';
import './InfoBox.css';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { Rnd as rnd } from "react-rnd";
import {
  closeDisplays
} from '../state/uiControl/uiControl.actions';
import { ShipInfo } from './ShipInfo';
import closeIcon from '../assets/images/close1.svg';

const dragBoxStyle = {
  position: 'absolute',
  zIndex: 409,
  backgroundColor: 'white',
  padding: '15px 0',
  color: 'black',
  textAlign: 'left',
  boxShadow: '9px 14px 15px 0 rgba(0,0,0,0.2)',
  borderStyle: 'solid',
  borderColor: 'black',
  borderWidth: '2px',
};

const Rnd: any = rnd;

export const ShipInfoContainer = ({ selectedShip, closeDisplays }: ShipInfoContainerProps) => {
  const defaultPosition = {
    x: window.innerWidth * .5 - 125,
    y: window.innerHeight * .5 - 155
  };

  if (selectedShip === null) return <div />;

  return (
    <div style={{ position: 'absolute', width: '100vw', height: '100vh' }}>
      <Rnd
        default={{
          x: defaultPosition.x,
          y: defaultPosition.y,
          width: '250px',
          height: '310px',
        }}
        disableDragging
        enableResizing={false}
        bounds='window'
        style={{ ...dragBoxStyle }}
      >
        <ShipInfo selectedShip={selectedShip} />
        <button className='closeButton' onClick={() => closeDisplays()}>
          <img alt="close" src={closeIcon} />
        </button>
      </Rnd>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  selectedShip: state.uiControl.selectedShip,
});

const dispatchProps = {
  closeDisplays
};

type ShipInfoContainerProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(mapStateToProps, dispatchProps)(ShipInfoContainer);